import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { BulletinService } from 'src/app/services/bulletin/bulletin.service';

@Component({
  selector: 'app-bulletin',
  templateUrl: './bulletin.component.html',
  styleUrls: ['./bulletin.component.scss']
})
export class BulletinComponent implements OnInit,OnDestroy {
  bulletin:string='';
  sub:Subscription;
  constructor(private bulletinService:BulletinService) { }

  ngOnInit(): void {
    this.sub=this.bulletinService.changeBulletin.subscribe(
      res=>{
        console.log(res);
        document.querySelector('.bulletinMarque').innerHTML=res;
      }
    );
  }
  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
